import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { nationalTaxServiceCredentialsDialogVar } from '../../../apollo/reactive-variables/alerts';
import LazyLoadImage from '../../images/LazyLoadImage';
import noCredentialsIcon from '../../../assets/icons/no_credentials';
import useSelectedCompany from '../../../hooks/useSelectedCompany';

const FullVersion = ({ source }) => {
  const company = useSelectedCompany();
  const { t } = useTranslation();
  const handleOpenCredentialsDialog = () => {
    nationalTaxServiceCredentialsDialogVar({
      open: true,
      autocomplete: true,
      showTerms: !company?.hasLendingAcceptedterms,
      source,
    });
  };
  return (
    <Stack
      direction="column"
      alignItems={{ mobile: 'center', desktop: 'center' }}
      px={{ mobile: 2, desktop: 0 }}
      mt={{ mobile: 4, desktop: 0 }}
      height="100%"
      justifyContent="center"
      spacing={{ desktop: 3, lg: 4 }}
      zIndex={1}
      position="relative"
    >
      <Box>
        <LazyLoadImage
          src={noCredentialsIcon}
          alt=""
          width={"100%"}
          height={{ mobile: 60, desktop: 70, lg: 98 }}
        />
      </Box>
      <Box
      textAlign="center">
        <Typography
          color= "gray.A700"
          variant="large_2"
          textAlign={{ mobile: 'center', desktop: 'center' }}
        >
          Necesitas actualizar tus credenciales del {t('National Tax Service acronym')} para poder ver y evaluar tus facturas
        </Typography>
      </Box>
      <Button variant="contained" color="primary" size="small" type="button" onClick={handleOpenCredentialsDialog}>
        <Typography variant="small_2" fontWeight={700} component="span">
          Actualizar clave
        </Typography>
      </Button>
    </Stack>
  );
};

FullVersion.propTypes = {
  source: PropTypes.string,
};

FullVersion.defaultProps = {
  source: null,
};

export default FullVersion;
